<template>
  <div class="NetlifyIdentityUserTable">
    <div class="d-flex align-items-end">
      <h2 v-if="hasTitle" class="ml-2 mb-3 d-inline-block">
        {{ title }}
      </h2>
    </div>
    <table>
      <thead>
        <tr class="d-flex py-2 pl-2 pr-5">
          <th 
            class="colStatus text-center"
            scope="col">
            Actief
          </th>
          <th 
            class="colName flex-grow-1"
            scope="col">
            Naam
          </th>
          <th 
            class="colRole"
            scope="col">
            Rol
          </th>
          <th 
            class="colControls"
            scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <NetlifyIdentityUserTableLine 
          v-for="(line, index) in users" 
          :key="index" 
          :user="line"
          @refresh="handleRefresh"
          @edit="handleEdit({ id: line.id })" />
      </tbody>
    </table>
  </div>
</template>

<script>
import NetlifyIdentityUserTableLine from './NetlifyIdentityUserTableLine'

export default {
  name: 'NetlifyIdentityUserTable',
  components: {
    NetlifyIdentityUserTableLine
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    users: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  computed: {
    hasTitle() {
      return this.title !== ''
    }
  },
  methods: {
    // Basically passing on event
    handleRefresh() {
      this.$emit('refresh')
    },
    handleEdit({ id }) {
      this.$emit('edit', { id })
    }
  }
}
</script>

<style lang="scss">
.NetlifyIdentityUserTable {
  width: 100%;
  user-select: none;

  h2 {
    font-size: 18px;
    color: #354052;
    font-weight: 600;
  }
  table {
    width: 100%;

    th {
      color: #7F8FA4;
      font-size: 14px;
      font-weight: normal;
    }
    th, td {
      &.colStatus {
        width: 100px
      }
      &.colName {
        min-width: 250px;
        flex-grow: 1;
      }
      &.colRole {
        text-transform: capitalize;
        width: 250px;
      }
      &.colControls {
        width: 155px
      }
    }
  }
}

</style>
